if (!customElements.get('plp-grid-item')) {
  customElements.define('plp-grid-item', class extends HTMLElement {
    constructor() {
      super();
    }

    resize() {
      this.flikity?.reloadCells();
    }

    flikity = null

    connectedCallback() {
      this.addEventListener('click', (e) => {
        // Modified clicks (new tab/window) on the real card link: let the
        // browser handle them natively instead of forcing same-tab navigation.
        // altKey deliberately excluded: native alt+click downloads the page,
        // so it keeps the base same-tab behavior instead.
        if ((e.metaKey || e.ctrlKey || e.shiftKey) && e.target.closest('a')) {
          return;
        }

        const productId = this.dataset.productId;
        const dataUrl = this.dataset.url;

        if (productId && dataUrl) {
          // Prevent default navigation behavior
          e.preventDefault();

          // Create a URL object from the current URL
          const url = new URL(window.location.href);

          // Set the product_id parameter
          url.searchParams.set('product_id', productId);

          // Replace the current URL without reloading the page
          window.history.replaceState({}, '', url.toString());

          // Navigate to the data-url
          window.location.href = dataUrl;
        }
      });

      try {
        this.flikity = new Flickity(this.querySelector('.plp-grid-item-mobile-image-wrapper'), {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          // A11y (#94): see the note on the fallback init below.
          accessibility: false,
        });
      } catch (error) {
        document.addEventListener('DOMContentLoaded', () => {
          this.flikity = new Flickity(this.querySelector('.plp-grid-item-mobile-image-wrapper'), {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            // A11y (#94): Flickity's default accessibility:true stamps
            // tabindex=0 on the carousel viewport - a tabbable, unnamed
            // descendant inside the card link (anchors must not contain
            // tabbable descendants). Touch/drag behavior is unaffected.
            accessibility: false,
          });
        });
      }

      this.querySelector('.plp-grid-item-mobile-image-wrapper img')?.addEventListener('load', () => {
        this.flikity?.reloadCells();
      });

      this.querySelector('.plp-grid-item-mobile-image-wrapper img')?.addEventListener('error', () => {
        this.flikity?.reloadCells();
      });
    }
  });
}

if (!customElements.get('new-plp')) {
  customElements.define(
    'new-plp',
    class extends HTMLElement {
      constructor() {
        super();
        this.gridWrapper = this.querySelector('.plp-grid-wrapper');
        this.loadMoreButton = this.querySelector('.load-more-btn');
        this.loadPreviousButton = this.querySelector('.plp-load-previous-btn button');
        // this.paginationText = this.querySelector('.plp-grid-item-pagination-text');
        this.isLoading = false;
      }

      connectedCallback() {
        // Check if product_id parameter exists in URL and scroll to that product
        this.checkProductIdAndScroll();

        // Add MutationObserver to watch header height changes
        const header = document.querySelector('#shopify-section-header');
        const filterSortContainer = document.querySelector('.plp-filter-sort-by-container');

        if (header && filterSortContainer) {
          // Function to update filter container position
          const updateFilterPosition = () => {
            const headerRect = header.getBoundingClientRect();
            const headerTop = headerRect.top;
            const headerHeight = header.offsetHeight;

            // If header's top is negative, set filter container's top to 0
            // Otherwise, set it to header's height
            filterSortContainer.style.top = headerTop < 0 ? '0px' : `${headerHeight}px`;
          };

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                updateFilterPosition();
              }
            });
          });

          // Start observing the header for style changes
          observer.observe(header, {
            attributes: true,
            attributeFilter: ['style'],
          });

          // Add scroll event listener
          window.addEventListener('scroll', () => {
            requestAnimationFrame(updateFilterPosition);
          });

          // Set initial top value
          updateFilterPosition();
        }

        // #226: a zero-result or query-less /search renders no [data-summary-count]
        // ("No items", or no paginate block at all), so this threw and aborted
        // connectedCallback before the load-more / load-previous bindings below.
        const initialSummaryCount = this.querySelector('[data-summary-count]');
        if (initialSummaryCount) {
          initialSummaryCount.innerHTML = this.querySelectorAll('.plp-grid-item:not(.plp-grid-banner)').length;
        }

        if (this.loadMoreButton) {
          this.loadMoreButton.addEventListener('click', this.loadMoreProducts.bind(this));
        }

        if (this.loadPreviousButton) {
          this.loadPreviousButton.addEventListener('click', this.loadPreviousProducts.bind(this));
        }

      }

      // Add new method to check for product_id in URL and scroll to it
      checkProductIdAndScroll() {
        const url = new URL(window.location.href);
        const productId = url.searchParams.get('product_id');

        if (productId) {
          // Find the grid item with the matching product ID
          setTimeout(() => {
            const targetElement = this.querySelector(`.plp-grid-item[data-product-id="${productId}"]`);

            if (targetElement) {
              // Scroll the element into view with smooth behavior
              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              
              // Remove product_id parameter from URL after scrolling
              setTimeout(() => {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('product_id');
                window.history.replaceState({}, '', newUrl.toString());
              }, 1000); // Wait for scroll animation to complete
            }
          }, 500); // Small delay to ensure DOM is fully loaded
        }
      }

      // Helper function to build a fetch URL with all parameters
      buildFetchUrl(targetUrl) {
        const url = new URL(window.location.href);
        const targetUrlObj = new URL(targetUrl, window.location.origin);

        // Get the page parameter from the target URL
        const pageParam = targetUrlObj.searchParams.get('page');

        if (pageParam) {
          // Update the page parameter in the current URL
          url.searchParams.set('page', pageParam);

          // Update browser history without reloading the page
          window.history.replaceState({}, '', url.toString());
        }

        // Start building the fetch URL
        let fetchUrl = targetUrl;
        const sortParam = url.searchParams.get('sort_by');

        // If we have a sort parameter, add it to the fetch URL if not already there
        if (sortParam && !targetUrlObj.searchParams.has('sort_by')) {
          fetchUrl += (fetchUrl.includes('?') ? '&' : '?') + `sort_by=${sortParam}`;
        }

        // Add any other filter parameters
        url.searchParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'section_id' && !targetUrlObj.searchParams.has(key)) {
            fetchUrl += (fetchUrl.includes('?') ? '&' : '?') + `${key}=${value}`;
          }
        });

        return fetchUrl;
      }

      // Helper function to update the product count summary
      updateProductCount() {
        const allPaginationText = this.querySelector('.plp-grid-container').querySelectorAll('.plp-grid-item-pagination-text[data-summary]');
        const lastPaginationText = allPaginationText[allPaginationText.length - 1];

        if (lastPaginationText) {
          lastPaginationText.querySelector('[data-summary-count]').textContent =
            this.querySelectorAll('.plp-grid-item:not(.plp-grid-banner)').length;
        }
      }

      // A11y (#102): mirror async grid updates into the visually-hidden
      // status region so screen readers hear pagination/filter results.
      announceGridStatus() {
        const liveRegion = document.querySelector('[data-plp-live-region]');
        if (!liveRegion) return;
        const shown = this.querySelectorAll('.plp-grid-item:not(.plp-grid-banner)').length;
        const totalEl = this.querySelector('[data-summary-total]');
        if (totalEl) {
          liveRegion.textContent = `You have viewed ${shown} of ${totalEl.textContent.trim()} items`;
        } else {
          liveRegion.textContent = shown > 0 ? `${shown} items shown` : 'No items';
        }
      }

      // Helper function to fetch HTML from a URL
      async fetchProducts(url) {
        const response = await fetch(url);
        const html = await response.text();

        // Parse the HTML and extract the new-plp component
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.querySelector('new-plp');
      }

      async loadPreviousProducts() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.loadPreviousButton.textContent = 'Loading...';

        try {
          const previousUrl = this.loadPreviousButton.dataset.previousUrl;

          // Build the fetch URL with all parameters
          const fetchUrl = this.buildFetchUrl(previousUrl);

          // #189 (review): same stale-response guard as loadMoreProducts --
          // a filter render swapping the grid mid-flight would otherwise get
          // pre-filter clones injected via the persistent gridWrapper element.
          const gridContainer = this.querySelector('.plp-grid-container');
          const renderGen = gridContainer ? gridContainer.dataset.plpRenderGen : null;

          // Fetch and parse the HTML
          const newPlp = await this.fetchProducts(fetchUrl);

          if (gridContainer && gridContainer.dataset.plpRenderGen !== renderGen) {
            this.loadPreviousButton.textContent = 'Load Previous';
            this.isLoading = false;
            return;
          }

          // Get the previous products
          const previousProducts = newPlp.querySelectorAll('.plp-grid-item');

          // Insert previous products at the beginning, preserving catalog order.
          // Capture the anchor once: inserting before the *live* firstChild on
          // each iteration leapfrogs the prior insert and reverses the page (#60).
          const anchor = this.gridWrapper.firstChild;
          previousProducts.forEach((product) => {
            this.gridWrapper.insertBefore(product.cloneNode(true), anchor);
          });

          // Update pagination
          const newPreviousButton = newPlp.querySelector('.plp-load-previous-btn button');

          if (newPreviousButton) {
            this.loadPreviousButton.parentElement.style.display = newPreviousButton.parentElement.style.display;
            this.loadPreviousButton.dataset.previousUrl = newPreviousButton.dataset.previousUrl;
            this.loadPreviousButton.textContent = 'Load Previous';
          }

          // Update product count
          this.updateProductCount();

          this.announceGridStatus();

          // Check if we need to scroll to a product after loading
          this.checkProductIdAndScroll();

          this.isLoading = false;
        } catch (error) {
          console.error('Error loading previous products:', error);
          this.loadPreviousButton.textContent = 'Load Previous';
          this.isLoading = false;
        }
      }

      async loadMoreProducts() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.loadMoreButton.textContent = 'Loading...';

        try {
          const nextUrl = this.loadMoreButton.dataset.next;

          // Build the fetch URL with all parameters
          const fetchUrl = this.buildFetchUrl(nextUrl);

          // #189 (review): snapshot the filter-render generation before the
          // fetch. plp-filter-drawer.js renderProducts bumps it on every grid
          // swap; if it moved while this fetch was in flight, the response is
          // stale (pre-filter) and must be discarded, not appended.
          const gridContainer = this.querySelector('.plp-grid-container');
          const renderGen = gridContainer ? gridContainer.dataset.plpRenderGen : null;

          // Fetch and parse the HTML
          const newPlp = await this.fetchProducts(fetchUrl);

          if (gridContainer && gridContainer.dataset.plpRenderGen !== renderGen) {
            this.loadMoreButton.textContent = 'Show me more';
            this.isLoading = false;
            return;
          }

          const fetchedWrapper = newPlp.querySelector('.plp-grid-wrapper');
          fetchedWrapper.classList.value = this.gridWrapper.classList.value;
          fetchedWrapper.classList.add('plp-grid-wrapper-loaded');

          // #189: strip the id before appending. The on-page wrapper already owns
          // id="collection-products" (sections/new-plp.liquid); a second element
          // with the same id is invalid HTML and, worse, leaves plp-filter-drawer.js
          // renderProducts swapping only the FIRST #collection-products on filter
          // apply -- stranding this appended page below with stale, unfiltered items.
          fetchedWrapper.removeAttribute('id');
          gridContainer.appendChild(fetchedWrapper);

          // #189: swap the existing summary for the fetched one instead of
          // appending a duplicate. The fetched page's summary is server-computed
          // for the new paginate state, so this keeps the visible "viewed N of M"
          // count correct. Remove-then-append (rather than replaceWith in place)
          // keeps the summary below the newest page, matching the server-rendered
          // wrapper-then-summary order. Keeping exactly one [data-summary] on the
          // page is load-bearing for sibling fix #203. If the fetched fragment
          // has no summary, the existing one is left intact.
          const fetchedSummary = newPlp.querySelector('.plp-grid-item-pagination-text[data-summary]');
          if (fetchedSummary) {
            const existingSummary = gridContainer.querySelector('.plp-grid-item-pagination-text[data-summary]');
            if (existingSummary) {
              existingSummary.remove();
            }
            gridContainer.appendChild(fetchedSummary);
            // Re-sync the visible count from the DOM card tally -- the same
            // source the live-region announcement uses -- so sighted and SR
            // users always agree even when paginate.items over-counts rendered
            // cards (mixed result types on product-unscoped search URLs).
            const summaryCount = fetchedSummary.querySelector('[data-summary-count]');
            if (summaryCount) {
              summaryCount.textContent = this.querySelectorAll('.plp-grid-item:not(.plp-grid-banner)').length;
            }
          }

          // Get the new products
          // const newProducts = newPlp.querySelectorAll('.plp-grid-item');
          // newProducts.forEach((product) => {
          //   this.gridWrapper.appendChild(product.cloneNode(true));
          // });

          // Update pagination
          const newPaginationLink = newPlp.querySelector('[data-more-btn]');

          if (newPaginationLink.dataset.next) {
            this.loadMoreButton.dataset.next = newPaginationLink.dataset.next;
            this.loadMoreButton.textContent = 'Show me more';
          } else {
            // No more products to load. Hide rather than remove: filter
            // re-renders re-sync data-next/display onto this element (#110),
            // and a removed node would leave nothing to update.
            this.loadMoreButton.style.display = 'none';
            this.loadMoreButton.removeAttribute('data-next');
            this.loadMoreButton.textContent = 'Show me more';
          }

          // Update product count
          // this.updateProductCount();

          this.announceGridStatus();

          // Check if we need to scroll to a product after loading
          this.checkProductIdAndScroll();

          this.isLoading = false;
        } catch (error) {
          console.error('Error loading more products:', error);
          this.loadMoreButton.textContent = 'Show me more';
          this.isLoading = false;
        }
      }

      initLazyLoadImages() {
        // Find all newly added images that need to be loaded
        const newImages = this.gridWrapper.querySelectorAll('img[data-src]:not([src])');

        newImages.forEach((img) => {
          // Set the src attribute to load the image
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }

          // If using a lazy loading library, you might need to trigger it here
          // For example, if using lazysizes:
          // if (window.lazySizes) {
          //   lazySizes.loader.unveil(img);
          // }
        });
      }
    }
  );
}